import qs from '@src/utils/query-string-util';

const CONTENT_QUERY_KEYS = ['categoryId', 'contentId', 'page'];

/**
 * 兼容 ?categoryId=xxx#/list 和 #/list?categoryId=xxx 两种参数位置。
 * Hash 路由参数优先，以保持现有移动端链接的行为。
 */
export function getContentRouteQuery(routeQuery = {}) {
  const pageQuery = qs.parse(window.location.search.replace(/^\?/, ''));
  return { ...pageQuery, ...routeQuery };
}

/**
 * 判断跳转字段是否为绝对地址
 *
 * 内容条目的 jump_link 有两种形态:
 * 1. 枚举值: content / link / stay, 需要前端自行拼地址;
 * 2. CMS 里直接配置的完整链接(如置顶Banner), 此时不能再拿 item.contentId 拼详情页,
 *    否则会跳到 Banner 自身那条空内容上.
 *
 * @param {string} value - jump_link 原始值
 * @returns {boolean}
 */
export function isAbsoluteUrl(value) {
  return typeof value === 'string' && /^(https?:)?\/\//i.test(value.trim());
}

/**
 * 按 PC 端约定生成内容页链接，同时保留 utm_source 等非内容页参数。
 *
 * HashRouter 下路由参数必须写在 hash 内部: #/path?key=value,
 * 拼在 hash 之前(?key=value#/path)会落到服务端 search 上, 与 PC 端约定不一致.
 */
export function createContentRouteUrl(routePath, query = {}) {
  const url = new URL(window.location.href);
  const pageQuery = qs.parse(url.search.replace(/^\?/, ''));

  CONTENT_QUERY_KEYS.forEach(key => {
    delete pageQuery[key];
  });

  const pageQueryStr = qs.stringify(pageQuery, { skipNulls: true });
  const routeQueryStr = qs.stringify(query, { skipNulls: true });

  url.search = pageQueryStr;
  url.hash = `${routePath}${routeQueryStr ? `?${routeQueryStr}` : ''}`;
  return url.toString();
}
